export default __webpack_public_path__ + "static/media/defaultIcon.85194522.svg";